module.exports = __webpack_public_path__ + "media/images/850/healthy-e67fa87a81e7d0253a676310ca3cf91b.webp";